const _ = require("lodash")

const { getCommonCss } = require("./common/common/common-css");
const { getCommonHeaders } = require("./common/common/common-headers");
const { getBasePatternCss } = require("./common/base-patterns/basepatterns");
const { getBaseImageCss } = require("./common/base-images/baseImage");
const { getTemplateCss } = require("./common/template-styles/template-style");
const { getTemplateBody } = require("./common/template-body/template-body");
const { footer } = require("./common/partials/footer");

const { gerErrorAlertEmail } = require("./emails/common/error-alert");
const { getRecoverCvEmail } = require("./emails/cv/recover-cv-request");

module.exports = {
    renderCvPreview: (cvOrig = {}, user = {}, addStyle = "") => {

        const cv = _.cloneDeep(cvOrig)

        const footerTemplate = footer(cv, user)
        const html = `
            <!doctype html>
            <html>
                <head>
                    ${getCommonHeaders(cv)}
                    <style>
                        ${getBasePatternCss(cv)}
                        ${getBaseImageCss(cv)}
                        ${getCommonCss(cv)}
                        ${getTemplateCss(cv)}
                    </style>
                    <style>${addStyle}</style>
                </head>
                <body>
                    ${getTemplateBody(cv)}
                </body>
            </html>
        `
        return { html, footerTemplate };
    },

    renderEmailPreview: (type, data) => {
        if (type === "error-alert")
            return gerErrorAlertEmail(data)
        if (type === "recover-cv-request")
            return getRecoverCvEmail(data)
    }
}